import { useDismiss } from "@/lib/hooks";

type Props = {
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  onCancel,
}: Props) {
  useDismiss(onCancel);
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 px-4" onClick={onCancel}>
      <div
        className="w-full max-w-sm rounded-lg border bg-background p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-sm font-semibold">{title}</h2>
        {message && <p className="mt-2 text-sm text-muted-foreground">{message}</p>}
        <div className="mt-5 flex justify-end gap-2">
          {cancelLabel && (
            <button
              onClick={onCancel}
              className="rounded-md border px-3 py-1.5 text-sm hover:bg-muted"
            >
              {cancelLabel}
            </button>
          )}
          <button
            onClick={onConfirm}
            className={`rounded-md px-3 py-1.5 text-sm text-white ${
              destructive ? "bg-destructive hover:bg-destructive/90" : "bg-primary hover:bg-primary/90"
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
